export default "__VITE_ASSET__Dq9pApCA__"